import { endpoints } from '../endpoints';
import { httpClient } from '../../lib/http-client';
import { usersResponseSchema, userSchema, type User } from '../../schemas/user';

/**
 * Fetches a list of all users.
 */
export async function fetchUsers(): Promise<User[]> {
  const { data } = await httpClient.get(endpoints.users.list);
  return usersResponseSchema.parse(data).users;
}

/**
 * Fetches the details of a specific user by their ID.
 */
export async function fetchUser(id: string): Promise<User> {
  const { data } = await httpClient.get(endpoints.users.detail(id));
  return userSchema.parse(data.user ?? data);
}

/**
 * Fetches all users associated with a specific planet.
 */
export async function fetchUsersByPlanet(planetId: string): Promise<User[]> {
  const { data } = await httpClient.get(endpoints.users.planet(planetId));
  return usersResponseSchema.parse(data).users;
}
